/**
 * Creates a single runner that ensures only one execution at a time
 * @util
 * @param options Configuration options
 * @returns State object with execute method
 */
export function createSingleRunner(options) {
    const { handler, state: initialState } = options;
    // Use provided state or create new one
    let state = {
        promise: undefined,
        running: false,
        error: undefined,
        execute,
        reset,
    };
    if (initialState) {
        state = initialState(state);
    }
    // Initialize state properties if not set
    return state;
    // Add execute method
    function execute() {
        // If already running, return the existing promise
        if (state.promise) {
            return state.promise;
        }
        // Create new promise for execution
        const promise = runHandler();
        state.promise = promise;
        return promise;
        async function runHandler() {
            state.running = true;
            state.error = undefined;
            try {
                return await handler();
            }
            catch (err) {
                state.error = err;
                throw err;
            }
            finally {
                // The finally clears state only if this execution is still the
                // tracked one — reset() swaps the promise, so a stale execution
                // resolving after reset() must not clobber the new state.
                if (state.promise === promise) {
                    state.running = false;
                    state.promise = undefined;
                }
            }
        }
    }
    function reset() {
        state.promise = undefined;
        state.running = false;
        state.error = undefined;
    }
}
//# sourceMappingURL=createSingleRunner.js.map